var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosGoogleGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2966_4295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.61753 11.9397V5.7899L1.71028 4.04505L0 3.07678V10.8545C0 11.455 0.486529 11.9397 1.08528 11.9397H3.61753Z",
    fill: "#3A435F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2969 11.9397H14.8291C15.4297 11.9397 15.9144 11.4531 15.9144 10.8544V3.07678L13.9772 4.18582L12.2969 5.78984V11.9397Z",
    fill: "#3A435F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61499 5.79175L3.35547 3.38882L3.61499 1.08899L7.95601 4.34478L12.297 1.08899L12.5873 3.26466L12.297 5.79175L7.95601 9.04754L3.61499 5.79175Z",
    fill: "#3A435F",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2969 1.08843V5.79119L15.9144 3.07807V1.63105C15.9144 0.288973 14.3824 -0.476104 13.3098 0.328766L12.2969 1.08843Z",
    fill: "#3A435F",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.0781L1.66377 4.32598L3.61753 5.79122V1.08846L2.60456 0.328795C1.53016 -0.476138 0 0.289002 0 1.63101V3.07804V3.0781Z",
    fill: "#3A435F",
    fillOpacity: 0.93
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2966_4295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9188,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGoogleGmail);
export default __webpack_public_path__ + "static/media/logos_google-gmail.53a6ddae4d3420f98a633150cfeb3cdc.svg";
export { ForwardRef as ReactComponent };